import { IcWarning } from '@assets/icons/24x24';
import {
  EnemyClassificationIcon,
  FriendClassificationIcon,
  SureIcon,
  SuspectClassificationIcon,
  UnknownClassificationIcon,
  UnsureIcon,
  WatchClassificationIcon,
} from '@assets/icons/24x24/target-ic-statusColor';
import {
  AircraftSignIcon,
  BirdSignIcon,
  DetectorSignIcon,
  DroneSignIcon,
  GroundVehicleSignIcon,
  HelicopterSignIcon,
  PersonSignIcon,
  RemoteControlSignIcon,
  ShipSignIcon,
  UnknownSignIcon,
  VcaSignIcon,
} from '@assets/icons/24x24/target-icSign';

import { FilterOption, MapFilters } from '@/types/filters.types';
import { SensorFamilyEnum } from '@/types/sensor/sensor.types';

export const mapFiltersAllChecked: MapFilters = {
  displayTargetDrone: true,
  displayTargetRemote: true,
  displayTargetAircraft: true,
  displayTargetVca: true,
  displayTargetHelicopter: true,
  displayTargetBird: true,
  displayTargetVehicle: true,
  displayTargetShip: true,
  displayTargetPerson: true,
  displayTargetTestBeacon: true,
  displayTargetUnknown: true,

  displayTrajectoryDrone: true,
  displayTrajectoryRemoteControl: true,
  displayTrajectoryAircraft: true,
  displayTrajectoryVca: true,
  displayTrajectoryHelicopter: true,
  displayTrajectoryBird: true,
  displayTrajectoryVehicle: true,
  displayTrajectoryShip: true,
  displayTrajectoryPerson: true,
  displayTrajectoryTestBeacon: true,
  displayTrajectoryUnknown: true,
  displayTrajectoryPinnedTarget: true,

  displayRfDetectionDroneUav: true,
  displayRfDetectionRemoteControl: true,
  displayRfDetectionUnknown: true,

  displayReliabilitySafe: true,
  displayReliabilityUnsafe: true,

  displayDangerLevelAuthorized: true,
  displayDangerLevelUnknown: true,
  displayDangerLevelFriend: true,
  displayDangerLevelSuspect: true,
  displayDangerLevelEnemy: true,

  displayLadSensorHolodrone: true,
  displayLadSensorSenid: true,
  displayLadSensorAeroscope: true,
  displayLadSensorAdsb: true,
  displayLadSensorArdronis: true,
  displayLadSensorSkyeye: true,
  displayLadSensorSkyjacker: true,
  displayLadSensorZmer: true,
  displayLadSensorHoloptics: true,
  displayLadSensorFlir: true,
  displayLadSensorRobinMax: true,
  displayLadSensorSpexer: true,
  displayLadSensorXenta: true,
  displayLadSensorAviso: true,

  displayPerimeterSensorAutomaton: true,
  displayPerimeterSensorCabinet: true,
  displayPerimeterSensorSegment: true,
  displayPerimeterSensorCamera: true,

  displaySensorInfoPosition: true,
  displaySensorInfoCoverage: true,
  displaySensorInfoPerimeterCameraFov: true,
  displaySensorInfoLadCameraFov: true,
  displaySensorInfoDisabledSensor: true,

  displayRadarZoneNoInitZone: true,
  displayRadarZoneInitMaskingZone: true,

  displayDangerZoneObservation: true,
  displayDangerZoneVigilance: true,
  displayDangerZoneCritical: true,

  displayFlightPlanActive: true,
  displayFlightPlanInactive: true,

  displayOtherInfoEvent: true,
  displayOtherInfoPoi: true,
  displayOtherInfoZoi: true,
  displayOtherInfoDetectionTargetLost: true,
  displayOtherInfoPlatformPerimeter: true,
  displaySpeedVector: true,

  displayMapLayerAeronautics: true,
};

export const mapFiltersAllUnchecked: MapFilters = {
  displayTargetDrone: false,
  displayTargetRemote: false,
  displayTargetAircraft: false,
  displayTargetVca: false,
  displayTargetHelicopter: false,
  displayTargetBird: false,
  displayTargetVehicle: false,
  displayTargetShip: false,
  displayTargetPerson: false,
  displayTargetTestBeacon: false,
  displayTargetUnknown: false,

  displayTrajectoryDrone: false,
  displayTrajectoryRemoteControl: false,
  displayTrajectoryAircraft: false,
  displayTrajectoryVca: false,
  displayTrajectoryHelicopter: false,
  displayTrajectoryBird: false,
  displayTrajectoryVehicle: false,
  displayTrajectoryShip: false,
  displayTrajectoryPerson: false,
  displayTrajectoryTestBeacon: false,
  displayTrajectoryUnknown: false,
  displayTrajectoryPinnedTarget: false,

  displayRfDetectionDroneUav: false,
  displayRfDetectionRemoteControl: false,
  displayRfDetectionUnknown: false,

  displayReliabilitySafe: false,
  displayReliabilityUnsafe: false,

  displayDangerLevelAuthorized: false,
  displayDangerLevelUnknown: false,
  displayDangerLevelFriend: false,
  displayDangerLevelSuspect: false,
  displayDangerLevelEnemy: false,

  displayLadSensorHolodrone: false,
  displayLadSensorSenid: false,
  displayLadSensorAeroscope: false,
  displayLadSensorAdsb: false,
  displayLadSensorArdronis: false,
  displayLadSensorSkyeye: false,
  displayLadSensorSkyjacker: false,
  displayLadSensorZmer: false,
  displayLadSensorHoloptics: false,
  displayLadSensorFlir: false,
  displayLadSensorRobinMax: false,
  displayLadSensorSpexer: false,
  displayLadSensorXenta: false,
  displayLadSensorAviso: false,

  displayPerimeterSensorAutomaton: false,
  displayPerimeterSensorCabinet: false,
  displayPerimeterSensorSegment: false,
  displayPerimeterSensorCamera: false,

  displaySensorInfoPosition: false,
  displaySensorInfoCoverage: false,
  displaySensorInfoPerimeterCameraFov: false,
  displaySensorInfoLadCameraFov: false,
  displaySensorInfoDisabledSensor: false,

  displayRadarZoneNoInitZone: false,
  displayRadarZoneInitMaskingZone: false,

  displayDangerZoneObservation: false,
  displayDangerZoneVigilance: false,
  displayDangerZoneCritical: false,

  displayFlightPlanActive: false,
  displayFlightPlanInactive: false,

  displayOtherInfoEvent: false,
  displayOtherInfoPoi: false,
  displayOtherInfoZoi: false,
  displayOtherInfoDetectionTargetLost: false,
  displayOtherInfoPlatformPerimeter: false,
  displaySpeedVector: false,

  displayMapLayerAeronautics: false,
};

export const filterOptionsTargetCategory: FilterOption[] = [
  {
    key: 'displayTargetDrone',
    label: 'target.identification.DRONE',
    Image: DroneSignIcon,
  },
  {
    key: 'displayTargetRemote',
    label: 'target.identification.REMOTE_CONTROL',
    Image: RemoteControlSignIcon,
  },
  {
    key: 'displayTargetAircraft',
    label: 'target.identification.AIRCRAFT',
    Image: AircraftSignIcon,
  },
  {
    key: 'displayTargetVca',
    label: 'target.identification.VCA',
    Image: VcaSignIcon,
  },
  {
    key: 'displayTargetHelicopter',
    label: 'target.identification.HELICOPTER',
    Image: HelicopterSignIcon,
  },
  {
    key: 'displayTargetBird',
    label: 'target.identification.BIRD',
    Image: BirdSignIcon,
  },
  {
    key: 'displayTargetVehicle',
    label: 'target.identification.GROUND_VEHICLE',
    Image: GroundVehicleSignIcon,
  },
  {
    key: 'displayTargetShip',
    label: 'target.identification.SHIP',
    Image: ShipSignIcon,
  },
  {
    key: 'displayTargetPerson',
    label: 'target.identification.PERSON',
    Image: PersonSignIcon,
  },
  {
    key: 'displayTargetTestBeacon',
    label: 'target.identification.BUILDING',
    Image: DetectorSignIcon,
  },
  {
    key: 'displayTargetUnknown',
    label: 'target.identification.UNKNOWN',
    Image: UnknownSignIcon,
  },
];

export const filterOptionsTrajectoryCategory: FilterOption[] = [
  {
    key: 'displayTrajectoryDrone',
    label: 'target.identification.DRONE',
  },
  {
    key: 'displayTrajectoryRemoteControl',
    label: 'target.identification.REMOTE_CONTROL',
  },
  {
    key: 'displayTrajectoryAircraft',
    label: 'target.identification.AIRCRAFT',
  },
  {
    key: 'displayTrajectoryVca',
    label: 'target.identification.VCA',
  },
  {
    key: 'displayTrajectoryHelicopter',
    label: 'target.identification.HELICOPTER',
  },
  {
    key: 'displayTrajectoryBird',
    label: 'target.identification.BIRD',
  },
  {
    key: 'displayTrajectoryVehicle',
    label: 'target.identification.GROUND_VEHICLE',
  },
  {
    key: 'displayTrajectoryShip',
    label: 'target.identification.SHIP',
  },
  {
    key: 'displayTrajectoryPerson',
    label: 'target.identification.PERSON',
  },
  {
    key: 'displayTrajectoryTestBeacon',
    label: 'target.identification.BUILDING',
  },
  {
    key: 'displayTrajectoryUnknown',
    label: 'target.identification.UNKNOWN',
  },
  {
    key: 'displayTrajectoryPinnedTarget',
    label: 'filters.trajectory.pinnedTarget',
  },
];

export const filterOptionsRfDetectionCategory: FilterOption[] = [
  {
    key: 'displayRfDetectionDroneUav',
    label: 'filters.rfDetection.droneAndUav',
  },
  {
    key: 'displayRfDetectionRemoteControl',
    label: 'target.identification.REMOTE_CONTROL',
  },
  {
    key: 'displayRfDetectionUnknown',
    label: 'target.identification.UNKNOWN',
  },
];

export const filterOptionsReliabilityCategory: FilterOption[] = [
  {
    key: 'displayReliabilitySafe',
    label: 'filters.reliability.sure',
    Image: SureIcon,
  },
  {
    key: 'displayReliabilityUnsafe',
    label: 'filters.reliability.unsure',
    Image: UnsureIcon,
  },
];

export const filterOptionsDangerLevelCategory: FilterOption[] = [
  {
    key: 'displayDangerLevelAuthorized',
    label: 'target.classification.FRIEND',
    Image: FriendClassificationIcon,
  },
  {
    key: 'displayDangerLevelUnknown',
    label: 'target.classification.UNKNOWN',
    Image: UnknownClassificationIcon,
  },
  {
    key: 'displayDangerLevelFriend',
    label: 'target.classification.WATCH',
    Image: WatchClassificationIcon,
  },
  {
    key: 'displayDangerLevelSuspect',
    label: 'target.classification.SUSPECT',
    Image: SuspectClassificationIcon,
  },
  {
    key: 'displayDangerLevelEnemy',
    label: 'target.classification.ENEMY',
    Image: EnemyClassificationIcon,
  },
];

export const filterOptionsLadSensorsCategory: FilterOption[] = [
  {
    key: 'displayLadSensorHolodrone',
    label: 'filters.ladSensors.holodrone',
    sensorFamily: SensorFamilyEnum.COLLABORATIVE,
  },
  {
    key: 'displayLadSensorSenid',
    label: 'filters.ladSensors.senid',
    sensorFamily: SensorFamilyEnum.COLLABORATIVE,
  },
  {
    key: 'displayLadSensorAeroscope',
    label: 'filters.ladSensors.aeroscope',
    sensorFamily: SensorFamilyEnum.COLLABORATIVE,
  },
  {
    key: 'displayLadSensorAdsb',
    label: 'filters.ladSensors.adsb',
    sensorFamily: SensorFamilyEnum.COLLABORATIVE,
  },
  {
    key: 'displayLadSensorArdronis',
    label: 'filters.ladSensors.ardronis',
    sensorFamily: SensorFamilyEnum.RF,
  },
  {
    key: 'displayLadSensorSkyeye',
    label: 'filters.ladSensors.skyeye',
    sensorFamily: SensorFamilyEnum.RF,
  },
  {
    key: 'displayLadSensorSkyjacker',
    label: 'filters.ladSensors.skyjacker',
    sensorFamily: SensorFamilyEnum.NEUTRAL,
  },
  {
    key: 'displayLadSensorZmer',
    label: 'filters.ladSensors.zmer',
    sensorFamily: SensorFamilyEnum.CAMERA,
  },
  {
    key: 'displayLadSensorHoloptics',
    label: 'filters.ladSensors.holoptics',
    sensorFamily: SensorFamilyEnum.CAMERA,
  },
  {
    key: 'displayLadSensorFlir',
    label: 'filters.ladSensors.flir',
    sensorFamily: SensorFamilyEnum.RADAR,
  },
  {
    key: 'displayLadSensorRobinMax',
    label: 'filters.ladSensors.robinmax',
    sensorFamily: SensorFamilyEnum.RADAR,
  },
  {
    key: 'displayLadSensorSpexer',
    label: 'filters.ladSensors.spexer',
    sensorFamily: SensorFamilyEnum.RADAR,
  },
  {
    key: 'displayLadSensorXenta',
    label: 'filters.ladSensors.xenta',
    sensorFamily: SensorFamilyEnum.RADAR,
  },
  {
    key: 'displayLadSensorAviso',
    label: 'filters.ladSensors.aviso',
    sensorFamily: SensorFamilyEnum.COLLABORATIVE,
  },
];

export const filterOptionsPerimeterSensorsCategory: FilterOption[] = [
  {
    key: 'displayPerimeterSensorAutomaton',
    label: 'filters.perimeterSensors.automaton',
  },
  {
    key: 'displayPerimeterSensorCabinet',
    label: 'filters.perimeterSensors.cabinet',
  },
  {
    key: 'displayPerimeterSensorSegment',
    label: 'filters.perimeterSensors.segment',
  },
  {
    key: 'displayPerimeterSensorCamera',
    label: 'filters.perimeterSensors.camera',
  },
];

export const filterOptionsSensorInfoCategory: FilterOption[] = [
  {
    key: 'displaySensorInfoPosition',
    label: 'filters.sensorInfo.sensorsPosition',
  },
  {
    key: 'displaySensorInfoCoverage',
    label: 'filters.sensorInfo.sensorCoverage',
  },
  {
    key: 'displaySensorInfoPerimeterCameraFov',
    label: 'filters.sensorInfo.perimeterCameraFov',
  },
  {
    key: 'displaySensorInfoLadCameraFov',
    label: 'filters.sensorInfo.ladCameraFov',
  },
  {
    key: 'displaySensorInfoDisabledSensor',
    label: 'filters.sensorInfo.disabledSensor',
  },
];

export const filterOptionsRadarZoneCategory: FilterOption[] = [
  {
    key: 'displayRadarZoneNoInitZone',
    label: 'filters.radarZone.niz',
  },
  {
    key: 'displayRadarZoneInitMaskingZone',
    label: 'filters.radarZone.imz',
  },
];

export const filterOptionsDangerZoneCategory: FilterOption[] = [
  {
    key: 'displayDangerZoneObservation',
    label: 'filters.dangerZone.observation',
  },
  {
    key: 'displayDangerZoneVigilance',
    label: 'filters.dangerZone.vigilance',
  },
  {
    key: 'displayDangerZoneCritical',
    label: 'filters.dangerZone.instantDanger',
  },
];

export const filterOptionsFlightplanCategory: FilterOption[] = [
  {
    key: 'displayFlightPlanActive',
    label: 'filters.flightplan.active',
  },
  {
    key: 'displayFlightPlanInactive',
    label: 'filters.flightplan.inactive',
  },
];

export const filterOptionsOtherInfoCategory: FilterOption[] = [
  {
    key: 'displayOtherInfoEvent',
    label: 'filters.otherInfo.event',
    Image: IcWarning,
  },
  {
    key: 'displayOtherInfoPoi',
    label: 'filters.otherInfo.poi',
  },
  {
    key: 'displayOtherInfoZoi',
    label: 'filters.otherInfo.zoi',
  },
  {
    key: 'displayOtherInfoPlatformPerimeter',
    label: 'filters.otherInfo.platformPerimeter',
  },
  {
    key: 'displaySpeedVector',
    label: 'filters.otherInfo.speedVector',
  },
];

export const filterOptionsMapLayerCategory: FilterOption[] = [
  {
    key: 'displayMapLayerAeronautics',
    label: 'filters.mapLayer.aeronautics',
  },
];
